module.exports = __webpack_public_path__ + "static/media/milky-way.8605f5a5.jpg";